export default [
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'T-CES-01',
        data: [
            {
                "cross_section": "90579",
                "up_cross_section": "90668",
                "down_cross_section": "90468",
                "error_id": "T-CES-01",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Bridge",
                "structure_opening": "structure",
                "up_dist": "79.00",
                "up_left_diff": "5.00",
                "up_left_ratio": "15.80",
                "down_dist": "101.00",
                "down_left_diff": "5.00",
                "down_left_ratio": "20.20",
                "up_right_diff": "5.00",
                "up_right_ratio": "15.80",
                "down_right_diff": "5.00",
                "down_right_ratio": "20.20",
                "up_left_calc": "1",
                "up_right_calc": "1",
                "down_left_calc": "1",
                "down_right_calc": "1",
                "around_structure_table": {},
                "skew": "7",
                "up_left_ratio_skew": "-15.72",
                "up_right_ratio_skew": "5.17",
                "down_left_ratio_skew": "5.59",
                "down_right_ratio_skew": "-12.90"
            },
            {
                "cross_section": "88297",
                "up_cross_section": "88429",
                "down_cross_section": "88173",
                "error_id": "T-CES-01",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Bridge",
                "structure_opening": "structure",
                "up_dist": "120.00",
                "up_left_diff": "5.00",
                "up_left_ratio": "24.00",
                "down_dist": "112.00",
                "down_left_diff": "5.00",
                "down_left_ratio": "22.40",
                "up_right_diff": "5.00",
                "up_right_ratio": "24.00",
                "down_right_diff": "5.00",
                "down_right_ratio": "22.40",
                "up_left_calc": "1",
                "up_right_calc": "1",
                "down_left_calc": "1",
                "down_right_calc": "1",
                "around_structure_table": {},
                "skew": "7",
                "up_left_ratio_skew": "-12.25",
                "up_right_ratio_skew": "5.99",
                "down_left_ratio_skew": "5.88",
                "down_right_ratio_skew": "-12.72"
            },
            {
                "cross_section": "82335",
                "up_cross_section": "82431",
                "down_cross_section": "82134",
                "error_id": "T-CES-01",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Bridge",
                "structure_opening": "structure",
                "up_dist": "76.00",
                "up_left_diff": "5.00",
                "up_left_ratio": "15.20",
                "down_dist": "181.00",
                "down_left_diff": "5.00",
                "down_left_ratio": "36.20",
                "up_right_diff": "5.00",
                "up_right_ratio": "15.20",
                "down_right_diff": "5.00",
                "down_right_ratio": "36.20",
                "up_left_calc": "1",
                "up_right_calc": "1",
                "down_left_calc": "1",
                "down_right_calc": "1",
                "around_structure_table": {},
                "skew": "52",
                "up_left_ratio_skew": "-0.97",
                "up_right_ratio_skew": "0.62",
                "down_left_ratio_skew": "0.71",
                "down_right_ratio_skew": "-0.85"
            },
            {
                "cross_section": "71466",
                "up_cross_section": "71614",
                "down_cross_section": "71321",
                "error_id": "T-CES-01",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Bridge",
                "structure_opening": "structure",
                "up_dist": "134.00",
                "up_left_diff": "5.00",
                "up_left_ratio": "26.80",
                "down_dist": "131.00",
                "down_left_diff": "5.00",
                "down_left_ratio": "26.20",
                "up_right_diff": "5.00",
                "up_right_ratio": "26.80",
                "down_right_diff": "5.00",
                "down_right_ratio": "26.20",
                "up_left_calc": "1",
                "up_right_calc": "1",
                "down_left_calc": "1",
                "down_right_calc": "1",
                "around_structure_table": {},
                "skew": "6",
                "up_left_ratio_skew": "-11.89",
                "up_right_ratio_skew": "6.23",
                "down_left_ratio_skew": "6.20",
                "down_right_ratio_skew": "-12.01"
            },
            {
                "cross_section": "54558",
                "up_cross_section": "54592",
                "down_cross_section": "54501",
                "error_id": "T-CES-01",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Bridge",
                "structure_opening": "structure",
                "up_dist": "20.00",
                "up_left_diff": "5.00",
                "up_left_ratio": "4.00",
                "down_dist": "43.00",
                "down_left_diff": "5.00",
                "down_left_ratio": "8.60",
                "up_right_diff": "5.00",
                "up_right_ratio": "4.00",
                "down_right_diff": "5.00",
                "down_right_ratio": "8.60",
                "up_left_calc": "1",
                "up_right_calc": "1",
                "down_left_calc": "1",
                "down_right_calc": "1",
                "around_structure_table": {},
                "skew": "31",
                "up_left_ratio_skew": "-3.75",
                "up_right_ratio_skew": "0.92",
                "down_left_ratio_skew": "1.24",
                "down_right_ratio_skew": "-2.30"
            },
            {
                "cross_section": "47779",
                "up_cross_section": "47830",
                "down_cross_section": "47720",
                "error_id": "T-CES-01",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Bridge",
                "structure_opening": "structure",
                "up_dist": "39.00",
                "up_left_diff": "5.00",
                "up_left_ratio": "7.80",
                "down_dist": "47.00",
                "down_left_diff": "5.00",
                "down_left_ratio": "9.40",
                "up_right_diff": "5.00",
                "up_right_ratio": "7.80",
                "down_right_diff": "5.00",
                "down_right_ratio": "9.40",
                "up_left_calc": "1",
                "up_right_calc": "1",
                "down_left_calc": "1",
                "down_right_calc": "1",
                "around_structure_table": {},
                "skew": "6",
                "up_left_ratio_skew": "119.82",
                "up_right_ratio_skew": "3.94",
                "down_left_ratio_skew": "4.33",
                "down_right_ratio_skew": "-75.01"
            },
            {
                "cross_section": "37173",
                "up_cross_section": "37257",
                "down_cross_section": "37069",
                "error_id": "T-CES-01",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Bridge",
                "structure_opening": "structure",
                "up_dist": "69.00",
                "up_left_diff": "5.00",
                "up_left_ratio": "13.80",
                "down_dist": "89.00",
                "down_left_diff": "5.00",
                "down_left_ratio": "17.80",
                "up_right_diff": "5.00",
                "up_right_ratio": "13.80",
                "down_right_diff": "5.00",
                "down_right_ratio": "17.80",
                "up_left_calc": "1",
                "up_right_calc": "1",
                "down_left_calc": "1",
                "down_right_calc": "1",
                "around_structure_table": {},
                "skew": "8",
                "up_left_ratio_skew": "-11.97",
                "up_right_ratio_skew": "4.28",
                "down_left_ratio_skew": "4.62",
                "down_right_ratio_skew": "-9.99"
            },
            {
                "cross_section": "115577",
                "up_cross_section": "115671",
                "down_cross_section": "115459",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Culvert",
                "structure_opening": "structure opening",
                "up_dist": "69.00",
                "up_left_diff": "25.90",
                "up_left_ratio": "2.66",
                "down_dist": "93.00",
                "down_left_diff": "25.90",
                "down_left_ratio": "3.59",
                "up_right_dist": "69.00",
                "up_right_diff": "16.00",
                "up_right_ratio": "4.31",
                "down_right_dist": "93.00",
                "down_right_diff": "16.00",
                "down_right_ratio": "5.81",
                "around_structure_table": {},
                "skew": "36",
                "up_left_ratio_skew": "-5.03",
                "up_right_ratio_skew": "0.77",
                "down_left_ratio_skew": "0.69",
                "down_right_ratio_skew": "-2.23"
            },
            {
                "cross_section": "111067",
                "up_cross_section": "111149",
                "down_cross_section": "110986",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Culvert",
                "structure_opening": "structure opening",
                "up_dist": "48.50",
                "up_left_diff": "18.50",
                "up_left_ratio": "2.62",
                "down_dist": "47.50",
                "down_left_diff": "18.50",
                "down_left_ratio": "2.57",
                "up_right_dist": "48.50",
                "up_right_diff": "17.00",
                "up_right_ratio": "2.85",
                "down_right_dist": "47.50",
                "down_right_diff": "17.00",
                "down_right_ratio": "2.79",
                "around_structure_table": {},
                "skew": "9",
                "up_left_ratio_skew": "4.76",
                "up_right_ratio_skew": "1.81",
                "down_left_ratio_skew": "1.68",
                "down_right_ratio_skew": "5.31"
            },
            {
                "cross_section": "106768",
                "up_cross_section": "106823",
                "down_cross_section": "106699",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Culvert",
                "structure_opening": "structure opening",
                "up_dist": "27.00",
                "up_left_diff": "20.40",
                "up_left_ratio": "1.32",
                "down_dist": "41.00",
                "down_left_diff": "20.40",
                "down_left_ratio": "2.01",
                "up_right_dist": "27.00",
                "up_right_diff": "8.30",
                "up_right_ratio": "3.25",
                "down_right_dist": "41.00",
                "down_right_diff": "8.30",
                "down_right_ratio": "4.94",
                "around_structure_table": {},
                "skew": "16",
                "up_left_ratio_skew": "2.51",
                "up_right_ratio_skew": "1.46",
                "down_left_ratio_skew": "1.04",
                "down_right_ratio_skew": "-12.33"
            },
            {
                "cross_section": "103320",
                "up_cross_section": "103408",
                "down_cross_section": "103249",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Culvert",
                "structure_opening": "structure opening",
                "up_dist": "58.00",
                "up_left_diff": "7.70",
                "up_left_ratio": "7.53",
                "down_dist": "41.00",
                "down_left_diff": "7.70",
                "down_left_ratio": "5.32",
                "up_right_dist": "58.00",
                "up_right_diff": "11.60",
                "up_right_ratio": "5.00",
                "down_right_dist": "41.00",
                "down_right_diff": "11.60",
                "down_right_ratio": "3.53",
                "around_structure_table": {},
                "skew": "18",
                "up_left_ratio_skew": "-5.30",
                "up_right_ratio_skew": "1.69",
                "down_left_ratio_skew": "1.74",
                "down_right_ratio_skew": "-28.45"
            }
        ]
    }
]